import { mq } from './Layout.styles'
import styled from '@emotion/styled'
import Atom from './Atom.styles'

/* Default sizes change if you need */
export const StyledH6 = styled(Atom)(props => (
  mq({
    fontWeight: [600],
    letterSpacing: [0.25],
    lineHeight: ['normal']
  })
))
